'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
Countries for which phone number formats are known/supported
**/

var countries = ['US', 'CA', 'PR', 'AS', 'AI', 'AG', 'BS', 'BB', 'BM', 'VG', 'KY', 'DM', 'DO', 'GD', 'GU', 'JM', 'MS', 'KN', 'LC', 'SX', 'VC', 'TT', 'TC', 'VI'];
exports.default = countries;